export const Circle = () => {
  return (
    <svg
      width="540"
      height="271"
      viewBox="0 0 540 271"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="540"
        height="271"
      >
        <rect y="0.34375" width="540" height="270" fill="white" />
      </mask>
      <g mask="url(#mask0)">
        <circle cx="270" cy="0.34375" r="270" fill="#F1E4FF" />
      </g>
    </svg>
  );
};
